import { memo } from 'react';

export const FiatInputLabel = memo(({ id, label }: { id?: string; label: string }) => (
	<label
		className='fiat_input_label color-neutral-50'
		htmlFor={id}
	>
		{label}
	</label>
));

FiatInputLabel.displayName = 'FiatInputLabel';
